export default {
  kakaoAppKey: '768323b2349cae7f8b043e8d98c13037',
};
